import {
  collapsedStyles,
  getDesktopDefaultStyles,
  getDesktopSupportWindowStyles,
  getMobileDefaultStyles,
  getMobileSupportWindowStyles,
  GetStylesParams,
} from '../consts';
import { type DisplayModes } from '../types';

export const getDisplayModeToResponsiveStyles = (
  params: GetStylesParams
): Record<DisplayModes, Record<string, object>> => ({
  FIC: {
    desktop: { ...getDesktopDefaultStyles(params) },
    mobile: { ...getMobileDefaultStyles(params) },
  },
  FAB: {
    desktop: { ...getDesktopSupportWindowStyles(params), ...collapsedStyles },
    mobile: { ...getMobileSupportWindowStyles(), ...collapsedStyles },
  },
  WINDOW: {
    desktop: getDesktopSupportWindowStyles(params),
    mobile: getMobileSupportWindowStyles(),
  },
  HIDDEN: {
    desktop: {},
    mobile: {},
  },
});
